/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type DevicesAvailabilityState =
  (typeof DevicesAvailabilityState)[keyof typeof DevicesAvailabilityState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DevicesAvailabilityState = {
  AvailabilityAvailable: 'available',
  AvailabilityUnavailable: 'unavailable',
  AvailabilityUnknown: 'unknown',
} as const;
